import { Navigate, useParams } from 'react-router-dom';

import { useGetRadioBase } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveRadioBase } from '../../shared/components';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';


export interface UpdateRadioBasePageInterface {}

const UpdateRadioBasePage: React.FC<UpdateRadioBasePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_radiobase)

  const { id } = useParams();
  const { data, isLoading } = useGetRadioBase(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_radiobase) return <Navigate to="/mantenimiento-operaciones/radio-bases" />;

  return <SaveRadioBase 
  
  titlePage="Editar RadioBase" editRadioBase={data.data} />;
};

export default UpdateRadioBasePage;
